export default __webpack_public_path__ + "static/media/instagramWhite.ed4585d7.svg";